import React from 'react'
import { Chip } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
    areaTag: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        fontWeight: 500,
        fontSize: '1.4rem',
        fontFamily: '"Kosugi Maru", sans-serif',
    },
}));

export const AreaTag = ({ content, size = 'small' }) => {
    const classes = useStyles();
    const displayContent = content || 'エリア指定無し';

    return (
        <Chip
            label={displayContent}
            className={classes.areaTag}
            size={size}
        />
    )
} 